// @ts-nocheck
import React, { useState, createRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import { getCSSHeight } from '@greenkub-fronts/shared/utils';

export interface AppearDownProps {
  isActive: boolean;
  duration: any;
  children: React.ReactElement;
  className?: string;
}

export const AppearDown = (props: AppearDownProps) => {
  const { isActive, duration, children, className = '' } = props;

  const [height, setHeight] = useState(0);
  const [overflow, setOverflow] = useState('hidden');

  const contentRef = createRef();

  const style = {
    padding: 0,
    overflow,
    height,
    transition: `${duration} height ease`,
  };

  return (
    <CSSTransition
      in={isActive}
      className="appearDown"
      addEndListener={(node, done) => {
        node.addEventListener('transitionend', done, false);
      }}
      onEnter={() => {
        setHeight(getCSSHeight(contentRef.current));
        setOverflow('hidden');
      }}
      onEntered={() => {
        //setHeight('auto')
        setOverflow('visible');
      }}
      onExit={() => {
        setHeight(0);
        setOverflow('hidden');
      }}
    >
      <div style={style}>
        {React.cloneElement(children, { ref: contentRef })}
      </div>
    </CSSTransition>
  );
};

export default AppearDown;
